import React from "react";
import Text from "@src/lib/ui/Text";

type Props = {
  message: string;
};

const DataNotAvailableMessage: React.FC<Props> = ({ message }) => {
  return (
    <div className="flex h-12 items-center justify-center rounded bg-gray-1">
      <Text variant="compact-description" className="text-gray-7">
        {message}
      </Text>
    </div>
  );
};

export default DataNotAvailableMessage;
